import { hasNonNullFields } from './general';

function setSelectOptions(data) {
  return data.map((d) => ({ label: d.name, value: d.id }));
}

function parseFilters(filters) {
  return filters.map((f) => {
    const { average, id, max, min, name } = f;
    return { average, id, max, min, name };
  });
}

function parseRegions(regions) {
  return regions.map((region) => {
    const { name, description } = region.attributes;

    return {
      label: description,
      value: name
    };
  });
}
function getScoreData(scoreDataObj) {
  const updatedScoreDataObj = { ...scoreDataObj };
  // manual assignment for score-2017 due to API constraints
  // if (updatedScoreDataObj.score && !updatedScoreDataObj.hasOwnProperty('score-2017')) {
  //   updatedScoreDataObj = {
  //     ...updatedScoreDataObj,
  //     'score-2017': updatedScoreDataObj.score
  //   };
  // }
  const scoresKeys = Object.keys(updatedScoreDataObj).filter((v) =>
    v.toLowerCase().startsWith('score')
  );
  const scoreData = {};

  scoresKeys.forEach((el) => {
    const updatedKey = el.split('-').join('');
    scoreData[updatedKey] = updatedScoreDataObj[el] ? String(updatedScoreDataObj[el]) : updatedScoreDataObj[el];
  });
  return scoreData;
}

function removeServerScoreData(dataObj) {
  const scoresKeys = Object.keys(dataObj).filter((v) =>
  v.toLowerCase().startsWith('score-')
);
  const updatedDataObj = { ...dataObj };
  scoresKeys.forEach(el => {
    delete updatedDataObj[el];
  });
  return updatedDataObj;
}

function transformObjectScoresFormat(obj) {
  return removeServerScoreData({ ...obj, ...getScoreData(obj) });
}

function getCountrySectorScores(data) {
  const scoreData = { ...data };
  let array = [];
  const yearCatScore = data['year-categories-scores'];
  if (yearCatScore && yearCatScore.length) {
    yearCatScore.forEach((el) => {
      array = array.concat(
        Object.keys(el).filter((v) => v.toLowerCase().startsWith('score'))
      );
    });// getting all years against which we have data
    const unique = array.filter((item, i, ar) => ar.indexOf(item) === i);
    unique.forEach((el) => {
      let sum = 0;
      yearCatScore.forEach((yearEle) => {
        sum = sum + (yearEle[el] && !isNaN(yearEle[el]) ? parseFloat(yearEle[el]) : 0);
      });
      const avg = sum / yearCatScore.length;
      scoreData[el] = data[el] || avg;
    });
  }
  return scoreData;
}
function setAsessments(countries) {
  const asessments = [];

  countries.forEach((c) => {
    const region = c.groups.map((group) => group.name);
    c['country-sectors'].forEach((cs) => {
      const scoreData = getScoreData(getCountrySectorScores(cs));
      asessments.push({
        id: cs.id,
        rank: cs.rank,
        score: cs.score,
        // score2017: cs.score,
        ...scoreData,
        region,
        sector: cs.sector.name,
        sectorId: cs.sector.id,
        name: `${c.name} (${
          cs.sector.name === 'oil-gas' ? 'oil & gas' : cs.sector.name
        })`
      });
    });
  });

  return asessments.filter(el => hasNonNullFields(el, 'score', ['score']));
}

function parseCountrySectors(normalizedData) {
  const { countrySectors, countries, sectors, groups } = normalizedData;
  const filterData = normalizedData.countrySectorCategories
    || normalizedData.countrySectorSubcategories || normalizedData.countrySectorIndicators;

  const compareSectorDataArray = Object.keys(countrySectors).map(key => {
    const countrySectorObject = countrySectors[key];
    const { country, sector } = countrySectorObject.relationships;
    const countryId = country.data.id;
    const sectorId = sector.data.id;

    const countryScoreData = Object.values(filterData).find(css => css.relationships.countrySector.data.id === countrySectorObject.id).attributes;
    const scoreData = { ...getScoreData(countryScoreData) };
    const countryObject = Object.values(countries).find(c => c.id === countryId);
    const countryData = countryObject.attributes;
    const groupIds = countryObject.relationships.groups.data.map(group => group.id);
    const sectorData = Object.values(sectors).find(s => s.id === sectorId).attributes;
    const groupData = groupIds.map(gid => Object.values(groups).find(group => group.id === gid).attributes.name);
    return {
      id: countrySectorObject.id,
      rank: countryScoreData.rank,
      score: countryScoreData.score,
      // score2017: countryScoreData.score,
      ...scoreData,
      sector: sectorData.name,
      region: groupData,
      iso: countryData.iso,
      name: `${countryData.name} (${sectorData.name === 'oil-gas' ? 'oil & gas' : sectorData.name})`
    };
  });
  return compareSectorDataArray;
}

export {
  setSelectOptions,
  setAsessments,
  parseFilters,
  parseCountrySectors,
  parseRegions,
  getScoreData,
  getCountrySectorScores,
  removeServerScoreData,
  transformObjectScoresFormat
};



// WEBPACK FOOTER //
// ./app/utils/data.js